// This is a purely presentational component, use with LibraryButtonWrapper.
import React from 'react';
import styled from 'astroturf/react';

const LibraryButton = styled.div`
  cursor: pointer;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  color: #777777;
  margin-right: 8px;
  padding: 5px 9px;
  align-items: center;

  &:hover {
    background: #ffffff;
    border-radius: 4px;
    color: #0849b8;
  }

  &:active {
    background: #dfeafd;
    border-radius: 4px;
  }
`;

type Props = {
  isBookmarked: boolean;
  onLibraryClick: () => void;
};

const LibraryButtonSearchRedesign = ({
  isBookmarked,
  onLibraryClick,
}: Props) => (
  <LibraryButton onClick={onLibraryClick}>
    {isBookmarked ? (
      <span>
        <i className="fa fa-check work-card--action-button-icon" />
        <span>Bookmarked</span>
      </span>
    ) : (
      <span>
        <i className="fa fa-plus work-card--action-button-icon" />
        <span>Bookmark</span>
      </span>
    )}
  </LibraryButton>
);

export default LibraryButtonSearchRedesign;
